import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-sendmail",
  templateUrl: "./sendmail.component.html",
  styleUrls: ["./sendmail.component.scss"],
})
export class SendmailComponent implements OnInit {
  public email: string;
  constructor(public dialogRef: MatDialogRef<SendmailComponent>) {}

  ngOnInit() {}

  save() {
    this.dialogRef.close(this.email);
  }

  close() {
    this.dialogRef.close();
  }
}
